export default {
  yourSkills: "Sus competencias",
  skills: "Competencias",
  skill: "Competencia",
  synthesis: {
    synthesis: "Síntesis",
    attachments: "Archivos adjuntos",
    evolution: "Evol.",
    noAttachment: "Sin archivo adjunto",
    notEvaluated: "No evaluado",
    notEvaluatedShort: "—",
    levelOf: ({ named }) => `Nivel ${named("value")} de ${named("max")}`,
    collapsePeriod: ({ named }) => `Ocultar el período ${named("name")}`,
    expandPeriod: ({ named }) => `Mostrar el período ${named("name")}`,
    skillCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "competencias" : "competencia"}`,
    attachmentCount: ({ named }) => `${named("count")} ${named("count") > 1 ? "archivos adjuntos" : "archivo adjunto"}`,
    showMoreAttachments: ({ named }) =>
      `Mostrar ${named("count")} ${named("count") > 1 ? "archivos adjuntos más" : "archivo adjunto más"}`,
    showLessAttachments: "Mostrar menos archivos adjuntos",
    mode: {
      title: "Modo de síntesis",
      avg: "Promedio",
      max: "Nota máxima",
      last: "Última evaluación",
    },
    hide: "Ocultar",
    loading: "Cargando la síntesis de competencias...",
    seeProgression: "Ver la progresión",
  },
  last_skill_update: "Último registro",
  duration: "Duración",
  Category: "Categoría",
  "Skills saved successfully": "Competencias registradas correctamente",
  next: "Siguiente",
  previous: "Anterior",
  seeHistoric: "Visualizar historial",
  resetSkill: "Reinicializar la competencia",
  justificativePieceSend: "Justificantes enviados",
  sendJustificativePiece: "Enviar justificantes",
  justificativeFileDeposited: ({ plural, named }) =>
    plural([`${named("count")} archivo subido`, `${named("count")} archivos subidos`]),
  impossibleJustificativeSending: "Opción de añadir justificantes después de la nota",
  stats: {
    no_data: "Ningún dato introducido todavía",
  },
  no_skills: "No se ha introducido ninguna competencia para esta categoría",
  no_skill_available: "No hay ninguna competencia introducida de momento",
  no_skill_complete: "No se ha completado ninguna competencia",
  skill_chart: "Gráfico de competencias",
  skill_category_chart: "Radar por bloque de competencias",
  empty_config: "Atención: la configuración del módulo de competencias no está finalizada",
  skill_progression_chart: "Progresión de la competencia",
  skill_chart_pdf_name: "gráfico-de-competencias",
  referential_visible: ({ plural }) => plural(["Referencia activa", "Referencia inactiva"]),
  session_visible: ({ plural }) => plural(["Sesión activa", "Sesión inactiva"]),
  generate_all_rncp_referential: "Generar todos los marcos de referencia France Compétences",
  admin_config: {
    enable_on_all_training_course: {
      title: "Utilizar la configuración de Admin en todas las promociones activas",
      confirm: {
        title: "Utilizar la configuración admin ?",
        subtitle:
          " Atención: esto aplicará la configuración del administrador a todas las promociones activas, incluso a aquellas que utilizan una configuración personalizada",
      },
    },
    disable_on_all_training_course: {
      title: "Utilizar la configuración personalizada en todas las promociones activas",
      confirm: {
        title: "Utilizar la configuración personalizada ?",
        subtitle:
          "Atención: esto afectará la configuración personalizada en todas las promociones activas, incluso en aquellas que utilizan la configuración del administrador",
      },
    },
  },
  skill_admin_config_in_use: "Actualmente está utilizando la configuración de administrador para los periodos.",
  notEvaluable: "No evaluable",
  notEvaluableAbbr: "NE",
  gradingScale: "Baremo de calificación",
  skillLevelOption: ({ named }) => `Nivel ${named("level")}`,
};
